module.exports = __webpack_public_path__ + "img/m.6afb0394.jpg";